import mock from './mockAdapter';

mock.onAny().passThrough();
